import { trellisPalette } from "../../../components/custom/analytics/palettes";
import { Row } from "react-bootstrap";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAppSelector } from "../../../redux/hooks";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { store } from "../../../redux/store";
import { apiClient } from "../../../zodios/client";
import { updateAmzOnboardingStatus, completeAmzProfileSelection } from "../../../redux/reducers/amzOnboardReducer";
import { AMAZON_ONBOARDING_STATUS_QUERY_KEY } from "../amazon/useAmazonOnboardingStatus";
import type { CSSProperties } from "react";

interface SkipToDashboardLinkProps {
  additionalStyles?: CSSProperties;
  onClick?: () => void;
}

const SkipToDashboardLink = ({ additionalStyles, onClick = () => {} }: SkipToDashboardLinkProps) => {
  const amz_onboard = useAppSelector((state) => state.amz_onboard);
  const queryClient = useQueryClient();
  const { t } = useTranslation(["onboarding"]);
  const setPreTrialStatus = useMutation({
    mutationFn: async () =>
      await apiClient.updateOrgStatus({
        status: "pre_trial",
        all_orgs: false,
      }),

    onSuccess: (res) => {
      store.dispatch(completeAmzProfileSelection());
      // Trigger redux refresh of user profile data
      store.dispatch(updateAmzOnboardingStatus({ ...amz_onboard, org_status: res.org_status }));
      // Invalidate cache so OnboardingGuard gets fresh data
      void queryClient.invalidateQueries({ queryKey: AMAZON_ONBOARDING_STATUS_QUERY_KEY });
    },
  });

  return (
    <Row className="text-center" style={additionalStyles}>
      <Link
        className="fs-5 text-decoration-none fw-500"
        style={{ color: trellisPalette[13] }}
        onClick={() => {
          onClick();
          if (!["active", "trial_active", "qore_active"].includes(amz_onboard.org_status)) {
            setPreTrialStatus.mutate();
          }
        }}
        to="/onboarding/v2/summary"
      >
        {t(($) => $.onboarding["Connect Later"])}
      </Link>
    </Row>
  );
};

export default SkipToDashboardLink;
